import { useEntityPageContext } from './EntityContext';

/**
 * The chart's download button, given the source's own button as `as`. The
 * filename, the image title and the element to screenshot all come off the
 * page, so only the data and the source's own props are worth passing.
 */
const EntityChartDownload = ({ as: Button, data, exportEntity, ...rest }) => {
    const { exportName, timeSeriesName, timeSeriesRef } =
        useEntityPageContext();

    return (
        <Button
            csvFilename={exportName(null, {
                kind: 'time-series',
                ...(exportEntity !== undefined && { entity: exportEntity }),
            })}
            imageTitle={timeSeriesName}
            data={data}
            wrapperRef={timeSeriesRef}
            {...rest}
        />
    );
};

export default EntityChartDownload;
